export default __webpack_public_path__ + "static/media/value5.a04db113.svg";